import * as React from 'react'


/*

Scrolls to page to the top when the wrapped component mounts. We need this because directing to a 
route containing a hash does keep the current scrollbar value intact. You want to use this on all
steps/pages

*/

export function withScrollToTop(Wrapped){
    
    return class extends React.Component<any, any>{


        componentDidMount(){
            window.scrollTo(0, 0);
        }
        

        render(){
            return <Wrapped { ...this.props } />
        }

    } as any;

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/scroll-to-top/index.tsx